<template>
  <div class="Browser">
    <img class="teslaLogo" src="@/assets/images/tesla-logo.png" />
    <input ref="address" v-model="address" type="text" placeholder="Insert Web Site URL" />
    <div class="goBtn" @click="go">GO</div>
    <div class="des">테슬라 풀스크린 브라우저</div>
    <div class="msg">Can only be used when the vehicle is parked.</div>
    <!-- <span class="resizeBtn" @click="winResize">Screen Resolution:{{sw}} px / {{sh}} px</span> -->

    <!-- <span class="resizeBtn" @click="winOpen">New Window :{{sw}} px / {{sh}} px</span> -->


    <!-- <iframe src="https://www.naver.com" style="position:absolute; left:100px; top:100px; width:500px; height:500px; border:1px solid #000000;"></iframe> -->
  </div>
</template>

<script>
export default {
  name: 'browser',
  data() {
    return {
      address:"",
      sw:0,
      sh:0,
    }
  },
  created(){
    this.sw = screen.availWidth;
    this.sh = screen.availHeight;
  },
  mounted(){
  },
  methods: {
    winOpen(){
      var win = window.open("https://teslcar.web.app", "teslcar", "width="+this.sw+",height="+this.sh);
      win.resizeTo( this.sw, this.sh );
    },
    winResize(){
      console.log("RESIZE");
      window.resizeTo(this.sw, this.sh);
      // document.documentElement.requestFullscreen();
    },
    go(){
      var tmpURL = this.address;
      if (tmpURL != "") {
        location.href = "https://www.youtube.com/redirect?q=" + tmpURL;
      } else {
        alert("Please check the URL.");
        this.$refs.address.focus();
      }
    },
  },
}
</script>

<style scoped>
  .Browser{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  img.teslaLogo {
    margin-bottom: 60px;
  }
  div.goBtn {
    position: relative;
    width: 100px;
    height: 100px;
    border: 2px solid #ff3333;
    margin: 0 auto;
    border-radius: 100%;
    box-sizing: border-box;
    line-height: 100px;
    font-size: 30px;
    color: #FF3333;
    transform: rotate(-0.03deg);
    cursor: pointer;
    user-select: none;
    transition: all 0.25s;
  }

  div.goBtn:hover {
    background-color: #FF3333;
    color: #FFFFFF;
    transition: all 0.25s;
  }

  div.goBtn:active {
    transform: rotate(-0.03deg) scale(0.9)
  }

  div.des {
    color: #666666;
    transform: rotate(-0.03deg);
    margin-top: 30px;
    letter-spacing: -0.5px;
  }

  div.msg {
    color: #FF3333;
    transform: rotate(-0.03deg);
    margin-top: 10px;
    letter-spacing: -0.5px;
  }

  div.Browser input {
    height: 50px;
    width: 800px;
    border: 1px solid #333333;
    margin-bottom: 40px;
    font-size: 20px;
    text-align: center;
    letter-spacing: -0.5px;
    transform: rotate(-0.028deg);
    border-radius: 5px;
    background-color: #FF3333;
    color: #FFFFFF;
    outline: none;
    font-weight: 200;
  }

  div.Browser input::placeholder {
    color: rgba(255, 255, 255, 0.6);
    font-weight: 200;
  }
  span.resizeBtn{
    font-size:11px; color:#666666; margin-top:10px; display:inline-block; padding:3px 10px;
  }
  span.resizeBtn:active{
    color:#FFFFFF; background-color:#666666;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Browser/index.vue